import React from 'react';
import { Block } from './block';

interface Props {
    children: React.ReactNode;
}
export function ErrorBox(props: Props) {
    return (<Block>{props.children}</Block>);
}